<template>
    <span>
        <div class="uk-grid-small uk-flex uk-flex-middle" uk-grid>
            <div class="uk-text-right uk-flex uk-flex-middle items-count">
                <slot name="listLength" />
            </div>

            <div class="uk-width-expand" />

            <div class="uk-text-right">
                <slot name="newButton" />
            </div>
        </div>

        <div class="uk-margin-small-top" />

        <div uk-filter="target: .js-filter">
            <div class="uk-grid-small uk-flex uk-flex-middle" uk-grid>
                <div>
                    <div
                        class="uk-grid-small uk-grid-divider uk-child-width-auto"
                        uk-grid>
                        <div>
                            <ul class="uk-subnav uk-subnav-pill" uk-margin>
                                <li class="uk-active" uk-filter-control>
                                    <a href="#">
                                        <Translate translation-key="all" />
                                    </a>
                                </li>
                            </ul>
                        </div>

                        <slot name="filter" />
                    </div>
                </div>
            </div>

            <div class="uk-margin-medium-top" />

            <ul
                v-if="show"
                :id="gridId"
                :class="
                    'js-filter uk-child-width-1-1 uk-grid-match ' +
                    (listView
                        ? 'uk-grid-small'
                        : 'uk-child-width-1-5@xl uk-child-width-1-4@l uk-child-width-1-3@m uk-child-width-1-2@s') +
                    ' ' +
                    classes
                "
                uk-grid>
                <slot />
            </ul>
        </div>
    </span>
</template>

<script>
import Translate from '@/components/Translate.vue';

export default {
    name: 'GenericView',
    components: {Translate},
    props: {
        classes: String,
        listView: Boolean,
    },
    data() {
        return {
            gridId: 'grid-generic-view',
            show: true,
        };
    },
    mounted() {
        let self = this;

        document.addEventListener('update-generic-view', function () {
            self.rerenderGrid();
        });
    },
    methods: {
        rerenderGrid() {
            this.show = false;
            let self = this;
            setTimeout(function () {
                self.show = true;
            }, 10);
        },
    },
};
</script>

<style lang="scss" scoped>
.uk-subnav > * > a {
    border-radius: $border-radius-next !important;
}

.uk-subnav-pill > .uk-active > a {
    color: #fff !important;
    background-color: $info-color !important;
}

.uk-subnav-pill > * > a {
    text-transform: initial !important;
    color: #333 !important;
    border: 1px solid $info-color !important;

    &:hover {
        color: #fff !important;
        background-color: $info-color-hover !important;
    }
}
</style>
